import { useEffect } from 'react';
import { brand } from '../mock';

const MIN_SHOW_MS = 600;
const MAX_WAIT_MS = 8000;

function preload(src) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = img.onerror = () => resolve();
    img.src = src;
  });
}

function windowLoaded() {
  if (document.readyState === 'complete') return Promise.resolve();
  return new Promise((resolve) => window.addEventListener('load', resolve, { once: true }));
}

function everythingReady() {
  const fonts = document.fonts?.ready ?? Promise.resolve();
  return Promise.all([
    windowLoaded(),
    fonts,
    preload('/jordievoorje-logo.png'),
    preload(brand.wallpaper),
  ]);
}

// Removes the static #splash from index.html once the page is truly loaded.
export function useInitialSplash() {
  useEffect(() => {
    const splash = document.getElementById('splash');
    if (!splash) return undefined;

    const started = performance.now();
    let cancelled = false;

    const timeout = new Promise((resolve) => setTimeout(resolve, MAX_WAIT_MS));

    Promise.race([everythingReady(), timeout]).then(() => {
      const remaining = Math.max(0, MIN_SHOW_MS - (performance.now() - started));
      setTimeout(() => {
        if (cancelled) return;
        splash.classList.add('splash--done');
        splash.setAttribute('aria-busy', 'false');
        setTimeout(() => splash.remove(), 500);
      }, remaining);
    });

    return () => {
      cancelled = true;
    };
  }, []);
}
